import React from 'react';
import { Icon } from 'react-fa';
import BEMHelper from 'react-bem-helper';

const bem = new BEMHelper({
  name: 'contact-view',
  prefix: 'planet-'
});

const ContactView = ({ isSelected, contact_type, contact }) => {
  console.log('isSelected-->', isSelected);
  return (
    <div {...bem(null, {selected: isSelected})}>
      <Icon name={contact_type}/> <span {...bem('value')}>{contact}</span>
    </div>
  );
};


export default ContactView



// WEBPACK FOOTER //
// ./src/components/ListEntity/Entities/Contact.js